import React, { useState } from "react";
import {ChevronsUpDown, PenSquare, Trash2} from "lucide-react";
import DeleteModal from "../Modal/DeleteModal";
import { can_visit } from "../../helpers";
import Skeleton from "react-loading-skeleton";
import AddAndEditNPIModal from "../Modal/AddAndEditNPIModal";

const styles = {
  display: "flex",
  alignItems: "center",
  gap: "5px",
  cursor: "pointer",
};

export default function NPIManagementDataTable(props) {
  const {
    account_id,
    location_id,
    tableData = [],
    handleDeleteRecord = () => {},
    reloadData = () => {},
    reloadDataFilter = {},
    handleUpdatedNPIInfo = () => {},
    dataLoading,
    setDataLoading = () => {},
    npiActionLoader = false,
    previousScrollPosition = 0,
    setPreviousScrollPosition = () => {},
    editNPIModal = false,
    setEditNPIModal = () => {}
  } = props;

  const [orderBy, setOrderBy] = useState();
  const [selectedNPI, setSelectedNPI] = useState({});
  const [deleteRecord, setDeleteRecord] = useState({});
  const [activeDeleteModal, setActiveDeleteModal] = useState(false);
  
  const handleOrderChange = (name, type = "asc") => {
    name = name.toString();
    setOrderBy(name);
    if (reloadDataFilter.order_by && reloadDataFilter.order_by[0] == name) {
      if (reloadDataFilter.order_by[1] == "asc") {
        type = "desc";
      }
    }
    const orderFilter = { order_by: [name, type.toString()] };
    const filter_merge = { ...reloadDataFilter, ...orderFilter };
    setDataLoading(true);
    reloadData(filter_merge);
  };

  const handleOpenEditNPIModal = (npi) => {
    setEditNPIModal(true);
    setSelectedNPI(npi);
    setPreviousScrollPosition(window.scrollY);
    window.scrollTo(0, 0);
  };

  return (
    <>
      <div className="docpro_table_responsive custom-scroll" style={{ minHeight: '200px' }}>
        <table className="docpro_mb_0">
          <thead>
            <tr>
              <th>
                <div
                  onClick={() => { handleOrderChange("npi_number"); }}
                  className={
                    orderBy === "npi_number" ? "docpro_accent_color" : ""
                  }
                >
                  <div style={styles}>
                    NPI <ChevronsUpDown size={"12"} />
                  </div>
                </div>
              </th>
              <th>
                <div
                  onClick={() => { handleOrderChange("npi_type"); }}
                  className={
                    orderBy === "npi_type" ? "docpro_accent_color" : ""
                  }
                >
                  <div style={styles}>
                    NPI Type <ChevronsUpDown size={"12"} />
                  </div>
                </div>
              </th>
              <th>
                <div
                  onClick={() => { handleOrderChange("organization_name"); }}
                  className={
                    orderBy === "organization_name" ? "docpro_accent_color" : ""
                  }
                >
                  <div style={styles}>
                    Practice Name <ChevronsUpDown size={"12"} />
                  </div>
                </div>
              </th>
              <th>
                <div
                  onClick={() => { handleOrderChange("first_name"); }}
                  className={
                    orderBy === "first_name" ? "docpro_accent_color" : ""
                  }
                >
                  <div style={styles}>
                    First Name <ChevronsUpDown size={"12"} />
                  </div>
                </div>
              </th>              
              <th>
                <div
                  onClick={() => { handleOrderChange("last_name"); }}
                  className={
                    orderBy === "last_name" ? "docpro_accent_color" : ""
                  }
                >
                  <div style={styles}>
                    Last Name <ChevronsUpDown size={"12"} />
                  </div>
                </div>
              </th>
              <th className="docpro_text_center"></th>
            </tr>
          </thead>
          <tbody>
          {!dataLoading ? (
            tableData.length > 0 ? (
              tableData?.map((item, index) => (
                <tr key={index}>
                  <td >{item?.npi_number}</td>
                  <td>
                    {item?.npi_type === 'organization' 
                    ? <span className="docpro_badge docpro_badge_cyan docpro_fs_12 ">Organization</span>
                    : item?.npi_type === 'individual'
                    ? <span className="docpro_badge docpro_badge_blue docpro_fs_12 ">Individual</span>
                    : '---'}
                  </td>
                  <td>{item?.organization_name}</td>
                  <td>{item?.first_name}</td>
                  <td>{item?.last_name}</td>
                  <td className="docpro_text_center">
                    {can_visit("administrator") && (
                      <div className="docpro_icon_btns">
                        {/* {(can_visit("settings") && can_visit("administrator")) && (
                          <button
                            type="button"
                            className="docpro_icon_btn last_btn_tip"
                            onClick={() => {
                              handleOpenEditNPIModal(item);
                            }}
                          >
                            <PenSquare width={18} height={18} />
                            <span className="docpro_tip">Edit NPI</span>
                          </button>
                        )} */}
                        {(can_visit("settings") && can_visit("administrator")) && (
                          <button
                            type="button"
                            className="docpro_icon_btn last_btn_tip docpro_icon_btn_red"
                            onClick={() => {
                              setDeleteRecord(item);
                              setActiveDeleteModal(true);
                              setPreviousScrollPosition(window.scrollY);
                              window.scrollTo(0, 0);
                            }}
                          >
                            <Trash2 width={18} height={18} />
                            <span className="docpro_tip">Delete</span>
                          </button>
                        )}
                      </div>
                    )}
                  </td>
                  
                </tr>
              ))
            ) : (
              <tr>
                <td className="no_data docpro_p_0" style={{ height: "200px" }} colSpan="6">
                  No data available
                </td>
              </tr>
            )
          ) : (
            Array.from({ length: 8 }).map((_, index) => (
              <tr key={index} style={{ height: '50px' }}>
                <td> <Skeleton width={`${3 + (index % 2)}rem`} borderRadius="8px"></Skeleton> </td>
                <td> <Skeleton width={`${4 + (index % 1.2)}rem`} borderRadius="8px"></Skeleton> </td>
                <td> <Skeleton width={`${5 + (index % 2.5)}rem`} borderRadius="8px"></Skeleton> </td>
                <td> <Skeleton width={`${4 + (index % 3)}rem`} borderRadius="8px"></Skeleton> </td>
                <td> <Skeleton width={`${3 + (index % 1.5)}rem`} borderRadius="8px"></Skeleton> </td>
                <td className="text-right"> <span className="mr-4 pr-2"><Skeleton width="3rem" borderRadius="8px"></Skeleton></span> </td>
              </tr>
            ))
          )}
          </tbody>
        </table>
      </div>
      {editNPIModal && (
        <AddAndEditNPIModal
          editModal={true}
          openModal={editNPIModal}
          setOpenModal={setEditNPIModal}
          account_id={account_id}
          location_id={location_id}
          handleNPIAction={handleUpdatedNPIInfo}
          npiActionLoader={npiActionLoader}
          previousScrollPosition={previousScrollPosition}
          selectedNPI={selectedNPI}
        />
      )}

      {activeDeleteModal && (
        <DeleteModal
          handleDelete={() => handleDeleteRecord(deleteRecord?.id)}
          name={deleteRecord?.npi_number || ''}
          activeModal={activeDeleteModal}
          setActiveModal={setActiveDeleteModal}
          previousScrollPosition={previousScrollPosition}
          setPreviousScrollPosition={setPreviousScrollPosition}
        />
      )}
    </>
  );
}
